import OrderDetailsModal from './OrderDetailsModal';
import OrderDeliveryDetailsModal from './OrderDeliveryDetailsModal';

export default {
  OrderDetailsModal,
  OrderDeliveryDetailsModal,
};
